/**
 * id：保存在后端的聊天类型
 * search_type：搜索聊天的时候应该搜索的类型，与id对应，chat-normal因为以前的聊天没有区分，所以其他类型都归类到chat-normal
 *
 * haveCommands: 是否有指令
 * getRelatedIssues: 获取三个关联问题
 * pointRule: 积分规则 undefined 或者
 * {
 funcName: "超时代AI 3.5",
 normal: -1,
 vip: -1,
 key: "gpt3",
 }
 与后端数据格式化后
 {
 normal: -1,
 normalText: "--",
 vip: -1,
 vipText: "--",
 };
 * includesCommands 包括什么指令，all代表所有指令，否则使用数组，传入指令id[]
 * uploadOptions 通用输入框的上传选项
 * status: "onlyPermanent", // 仅限终身会员开放
 *  */
import { formatPointText, getRule } from "@/utils/constant/pointRule";
import { INPUT_COMMAND } from "@/utils/constant/data";
import { CHAT_MODEL } from "@/utils/constant/model.js";
const GPT_MODEL = [
  {
    id: "chat-normal",
    icon: "icon-star",
    type: "chat",
    search_type: [
      "chat-normal",
      "multi_app",
      "multi-file-app",
      "chat-dalle3",
      "",
      "null",
    ],
    name: CHAT_MODEL["chat-normal"].name,
    phoneName: "GPT 3.5",
    historyListName: "3.5综合",
    prompt:
      "免费畅享，无需消耗积分；响应速度快，全方位支持多种指令与基础问答对话",
    advantage: [
      "超强理解能力，准确理解各种复杂的自然语言表达",
      "速度更快、更自然，堪比人类对话的反应速度",
      "可根据不同的指令和场景进行调整，适应不同的需求",
    ],
    // 可使用指令
    haveCommands: true,
    includesCommands: INPUT_COMMAND.map((item) => item.id),
    uploadOptions: {
      show: true,
      allow_type: ["image", "document"],
    },
    getRelatedIssues: true,
    needParams: [
      "model",
      "mode",
      "is_version4",
      "temperature",
      "is_deep_search",
    ],
    status: "issue",
    free: true,
    // 积分显示规则
    pointRule: getRule("chat", "gpt3"),
  },
  // {
  //   id: "chat-extreme-speed",
  //   icon: "icon-a-rongqi2",
  //   type: "chat",
  //   phoneName: "自研 4.0",
  //   // 可使用指令
  //   haveCommands: false,
  //   search_type: ["chat-extreme-speed"],
  //   name: "自研 4.0 文字模型",
  //   needParams: [{ model_type: "doubao" }],
  //   getRelatedIssues: true,
  // },
  {
    id: "deep-seek-v3",
    icon: "icon-classify",
    type: "chatDS",
    search_type: ["deep-seek-v3"],
    name: CHAT_MODEL["deep-seek-v3"].name,
    // 历史内容的聊天名称
    historyListName: "DS V3模型",
    phoneName: "DS V3模型",
    prompt:
      "响应速度快，在知识类任务、算法和工程代码场景等方面表现出色，数学能力超过所有开源闭源模型",
    advantage: [
      "处理各种复杂任务时，展现出卓越的逻辑思维",
      "在推理/代码/文本处理方面，比3.5有更明显的提升",
      "速度更快、更自然，堪比人类对话的反应速度",
    ],
    // 可使用指令
    haveCommands: true,
    includesCommands: ["AISS"],
    uploadOptions: {
      show: true,
      allow_type: ["image", "document"],
    },
    needParams: [{ model_type: "deep_seek", draw_type: 3 }],
    getRelatedIssues: false,
    status: "issue",
    free: true,
    // 积分显示规则
    pointRule: getRule("chat", "gpt3"),
  },
  {
    id: "R1",
    icon: "icon-classify",
    type: "chatDS",
    search_type: ["R1"],
    name: CHAT_MODEL["R1"].name,
    // 历史内容的聊天名称
    historyListName: "R1推理模型",
    phoneName: "DeepSeek R1",
    prompt:
      "国产大模型，在数学、代码、自然语言推理等任务上，性能与 GPTo1 模型相当，能有效处理复杂推理任务",
    advantage: [
      "逻辑能力超强，回复准确度高，适用于写作和编程",
      "处理复杂任务展现卓越逻辑思维，推理、代码等方面",
      "反应速度快且自然，堪比人类对话",
    ],
    // 可使用指令
    haveCommands: true,
    includesCommands: ["AISS"],
    uploadOptions: {
      show: false,
      allow_type: [],
    },
    needParams: [{ model_type: "deep_seek_reasoner", draw_type: 3 }],
    getRelatedIssues: false,
    status: "issue",
    // 积分显示规则
    pointRule: getRule("chat", "deep_seek_reasoner"),
  },
  {
    id: "agent",
    type: "agent",
    name: "智能体模型",
    historyListName: "智能体",
    // 可使用指令
    haveCommands: false,
    getRelatedIssues: false,
    search_type: ["default_app", "custom_app"],
    needParams: [
      { non_chat: true },
      "is_internet",
      "is_version4",
      "temperature",
    ],
    status: "issue",
    // 积分显示规则
    pointRule: getRule("chat", "non_chat"),
  },
  {
    // 智能体 - 角色对话，另外的 type，以区分聊天记录
    id: "personify",
    type: "personify",
    name: "智能体-角色对话",
    historyListName: "角色对话",
    // 可使用指令
    haveCommands: false,
    getRelatedIssues: false,
    search_type: ["personify"],
    needParams: [
      { non_chat: true },
      "is_internet",
      "is_version4",
      "temperature",
    ],
    status: "issue",
    // 积分显示规则
    pointRule: getRule("chat", "non_chat"),
  },
  {
    id: "deep-seek",
    icon: "icon-classify",
    type: "chat",
    search_type: ["deep-seek"],
    name: CHAT_MODEL["deep-seek"].name,
    // 历史内容的聊天名称
    historyListName: "3.5 推理",
    phoneName: "3.5 推理",
    prompt:
      "逻辑推理精准高效，思路清晰。代码能力出色，生成快速且质量高，优化代码提升性能，多语言支持广泛。",
    // 可使用指令
    haveCommands: false,
    uploadOptions: {
      show: false,
      allow_type: [],
    },
    needParams: [{ model_type: "deep_seek" }],
    getRelatedIssues: true,
    fold: true,
    foldName: "其他模型",
    foldIcon: "icon-classify",
    status: "issue",
    // 积分显示规则
    pointRule: getRule("chat", "gpt3"),
  },
  {
    id: "chat-plus",
    icon: "icon-a-rongqi2",
    type: "chat",
    name: CHAT_MODEL["chat-plus"].name,
    phoneName: "GPT 4.0",
    historyListName: "4.0文字",
    fold: true,
    foldName: "其他模型",
    foldIcon: "icon-classify",
    prompt:
      "超强的逻辑能力，回复准确度高，适用于各种复杂的对话、写作、编程等场景",
    advantage: [
      "处理各种复杂任务时，展现出卓越的逻辑思维",
      "在推理/代码/文本处理方面，比3.5有更明显的提升",
      "速度更快、更自然，堪比人类对话的反应速度",
    ],
    search_type: ["chat-plus"],
    points: [10, 5],
    // 可使用指令
    haveCommands: true,
    uploadOptions: {
      show: true,
      allow_type: ["image", "document"],
    },
    includesCommands: ["AISS", "JTDY"],
    needParams: [{ is_version4: true }, "is_deep_search"],
    getRelatedIssues: true,
    status: "issue",
    // 积分显示规则
    pointRule: getRule("chat", "gpt4"),
  },
  {
    id: "GPT4.0",
    icon: "icon-classify",
    type: "chat",
    name: CHAT_MODEL["GPT4.0"].name,
    phoneName: "GPT4.0",
    historyListName: "4.0写作",
    search_type: ["GPT4.0"],
    prompt:
      "小说写作模型，擅长激发原创写作思维。超长上下文 200K 的对话能力，最大可输出 8192token",
    points: [10, 5],
    // 可使用指令
    haveCommands: false,
    uploadOptions: {
      show: false,
      allow_type: [],
    },
    needParams: [{ model_type: "write4" }],
    getRelatedIssues: true,
    fold: true,
    foldName: "其他模型",
    foldIcon: "icon-classify",
    status: "issue",
    // 积分显示规则
    pointRule: getRule("chat", "claude"),
  },
  {
    id: "GPT4o",
    icon: "icon-classify",
    type: "chat",
    name: CHAT_MODEL["GPT4o"].name,
    historyListName: "GPT4o",
    search_type: ["GPT4o"],
    phoneName: "GPT4o",
    fold: true,
    foldName: "其他模型",
    foldIcon: "icon-classify",
    prompt:
      "反应速度快、多模态交互强、语言能力出色，接近人类的理解能力和流畅表达",
    advantage: [
      "逻辑能力超强，回复准确度高，适用于写作和编程",
      "处理复杂任务展现卓越逻辑思维，推理、代码等方面",
      "反应速度快且自然，堪比人类对话",
    ],
    points: [10, 5],
    // 可使用指令
    haveCommands: false,
    uploadOptions: {
      show: true,
      allow_type: ["document"],
    },
    status: "issue",
    needParams: [{ model_type: "all" }],
    getRelatedIssues: true,
    // 积分显示规则
    pointRule: getRule("chat", "gpt4_all"),
  },
  {
    id: "GPTo1",
    icon: "icon-classify",
    type: "chat",
    search_type: ["GPTo1"],
    name: CHAT_MODEL["GPTo1"].name,
    // 历史内容的聊天名称
    historyListName: "GPTo1",
    phoneName: "GPT 4.0",
    prompt:
      "全新 AI 大模型，专门解决比此前的科学、代码和数学模型能做到的更难的问题，实现复杂推理",
    // 可使用指令
    haveCommands: false,
    uploadOptions: {
      show: false,
      allow_type: [],
    },
    needParams: [{ model_type: "4o1" }],
    getRelatedIssues: true,
    fold: true,
    foldName: "其他模型",
    foldIcon: "icon-classify",
    status: "onlyPermanent",
    // 积分显示规则
    pointRule: getRule("chat", "gpt4o1"),
  },
  {
    id: "GPTo3",
    icon: "icon-classify",
    type: "chat",
    search_type: ["GPTo3"],
    name: CHAT_MODEL["GPTo3"].name,
    // 历史内容的聊天名称
    historyListName: "GPTo3",
    phoneName: "GPT o3",
    prompt:
      "o3-mini是2025年1月31日最新发布且最有效益的推理模型；在数学、科学、编程等 STEM 领域表现优秀",
    // 可使用指令
    haveCommands: false,
    uploadOptions: {
      show: false,
      allow_type: [],
    },
    needParams: [{ model_type: "4o3" }],
    getRelatedIssues: true,
    fold: true,
    foldName: "其他模型",
    foldIcon: "icon-classify",
    status: "issue",
    // 积分显示规则
    pointRule: getRule("chat", "gpt4o3"),
  },
  {
    id: "rewrite",
    icon: "icon-star",
    type: "deep_seek_reasoner",
    search_type: ["rewrite"],
    name: "内容重写",
    phoneName: "AI 3.5",
    historyListName: "3.5综合",
    prompt:
      "免费畅享，无需消耗积分；响应速度快，全方位支持多种指令与基础问答对话",
    advantage: [
      "超强理解能力，准确理解各种复杂的自然语言表达",
      "速度更快、更自然，堪比人类对话的反应速度",
      "可根据不同的指令和场景进行调整，适应不同的需求",
    ],
    // 可使用指令
    haveCommands: true,
    includesCommands: INPUT_COMMAND.map((item) => item.id),
    uploadOptions: {
      show: true,
      allow_type: ["image", "document"],
    },
    getRelatedIssues: false,
    needParams: [{ model_type: "deep_seek" }],

    status: "issue",
    free: true,
    // 积分显示规则
    pointRule: getRule("chat", "gpt3"),
  },
  {
    id: "contentCompletion",
    icon: "icon-star",
    type: "contentCompletion",
    search_type: ["contentCompletion"],
    name: "内容补全",
    phoneName: "AI 3.5",
    historyListName: "3.5综合",
    prompt:
      "免费畅享，无需消耗积分；响应速度快，全方位支持多种指令与基础问答对话",
    advantage: [
      "超强理解能力，准确理解各种复杂的自然语言表达",
      "速度更快、更自然，堪比人类对话的反应速度",
      "可根据不同的指令和场景进行调整，适应不同的需求",
    ],
    // 可使用指令
    haveCommands: true,
    includesCommands: INPUT_COMMAND.map((item) => item.id),
    uploadOptions: {
      show: true,
      allow_type: ["image", "document"],
    },
    getRelatedIssues: false,
    needParams: [{ model_type: "deep_seek" }],
    status: "issue",
    free: true,
    // 积分显示规则
    pointRule: getRule("chat", "gpt3"),
  },
  {
    id: "novelWrite",
    icon: "icon-star",
    type: "novelWrite",
    search_type: ["novelWrite"],
    name: "小说创作",
    phoneName: "AI 3.5",
    historyListName: "3.5综合",
    prompt:
      "免费畅享，无需消耗积分；响应速度快，全方位支持多种指令与基础问答对话",
    advantage: [
      "超强理解能力，准确理解各种复杂的自然语言表达",
      "速度更快、更自然，堪比人类对话的反应速度",
      "可根据不同的指令和场景进行调整，适应不同的需求",
    ],
    // 可使用指令
    haveCommands: true,
    includesCommands: INPUT_COMMAND.map((item) => item.id),
    uploadOptions: {
      show: true,
      allow_type: ["image", "document"],
    },
    getRelatedIssues: false,
    needParams: [{ model_type: "deep_seek" }],

    status: "issue",
    free: true,
    // 积分显示规则
    pointRule: getRule("chat", "gpt3"),
  },
  {
    id: "contentWrite",
    icon: "icon-star",
    type: "contentWrite",
    search_type: ["contentWrite"],
    name: "长文写作",
    phoneName: "AI 3.5",
    historyListName: "3.5综合",
    prompt:
      "免费畅享，无需消耗积分；响应速度快，全方位支持多种指令与基础问答对话",
    advantage: [
      "超强理解能力，准确理解各种复杂的自然语言表达",
      "速度更快、更自然，堪比人类对话的反应速度",
      "可根据不同的指令和场景进行调整，适应不同的需求",
    ],
    // 可使用指令
    haveCommands: true,
    includesCommands: INPUT_COMMAND.map((item) => item.id),
    uploadOptions: {
      show: true,
      allow_type: ["image", "document"],
    },
    getRelatedIssues: false,
    needParams: [{ model_type: "deep_seek" }],

    status: "issue",
    free: true,
    // 积分显示规则
    pointRule: getRule("chat", "gpt3"),
  },
];

// function getCommandIds(idType) {
//   if (idType === "all") {
//     return INPUT_COMMAND.map((item) => item.id);
//   }
//   // if()
// }

function formatPointRule(pointRuleDetail) {
  // pointRuleDetail 从后端获取的
  GPT_MODEL.forEach((item) => {
    const { pointRule } = item;
    if (pointRule && !pointRule.isFormat) {
      const ruleKey = pointRule.key;
      item.pointRule = formatPointText(pointRule, pointRuleDetail?.[ruleKey]);
    }
  });
  return GPT_MODEL;
}

function findModelById(id) {
  return (
    GPT_MODEL.find((item) => item.id === id) ||
    GPT_MODEL.find((item) => item.id === "chat-normal")
  );
}

function groupByTypeFold(type) {
  const modelList = findModelByType(type);
  const foldList = [];
  const resultList = modelList
    .filter((item) => item.type === type)
    .reduce((arr, item) => {
      if (item.fold) {
        const index = foldList.findIndex((fold) => fold.name === item.foldName);
        if (index > -1) {
          foldList[index].child.push(item);
        } else {
          foldList.push({
            name: item.foldName,
            icon: item.foldIcon,
            child: [item],
          });
        }
        return arr;
      }
      arr.push(item);
      return arr;
    }, []);
  return resultList.concat(foldList);
}

function findModelByType(type) {
  return GPT_MODEL.filter((item) => item.type === type);
}

function getSearchType(type) {
  const list = GPT_MODEL.filter((item) => item.type === type);
  const search_type = list.map((item) => item.search_type);
  const searchArr = search_type.reduce((pre, cur) => {
    const searchArr = [...pre];
    if (typeof cur === "string") {
      searchArr.push(cur);
    } else if (Array.isArray(cur)) {
      searchArr.push(...cur);
    }
    return searchArr;
  }, []);
  // console.log("searchArr", searchArr);
  return searchArr.join(",");
}

function getSearchTypes(types) {
  const typesData = types.map((type) => getSearchType(type));
  const ret = typesData.join(",");

  return ret;
}

// 保存聊天记录的 type 匹配模型
// 这个 type 可能为 undefined ，当3.5处理
function findModelByChatType(chatType) {
  if (!chatType) chatType = "chat-normal";
  let model;
  GPT_MODEL.forEach((item) => {
    if (item.id === chatType) {
      model = item;
    }
    if (item.search_type && item.search_type.includes(chatType)) {
      model = item;
    }
  });
  return model || findModelById("chat-normal");
}

export {
  GPT_MODEL,
  findModelById,
  findModelByType,
  getSearchType,
  getSearchTypes,
  findModelByChatType,
  formatPointRule,
  groupByTypeFold,
};
